import { StepperVariant } from '../types/stepper';
import {
  CREDIT_FORM_KEYS,
  CreditApplicationStatus,
  CreditConfig,
  YearsInBusiness,
  billingDetailsFormSchema,
  companyDetailsFormSchema,
  insuranceDetailsFormSchema,
  reviewFormSchema,
} from '../types/credit';

export const creditConfig: CreditConfig = {
  stepperConfig: {
    companyDetails: {
      showInStepper: true,
      stepLabel: 'Company Details',
      backLabel: 'company info',
      key: CREDIT_FORM_KEYS.COMPANY_DETAILS,
      schema: companyDetailsFormSchema,
      fields: [...Object.keys(companyDetailsFormSchema.shape).map((e) => 'companyDetails.' + e)],
    },
    billingDetails: {
      showInStepper: true,
      stepLabel: 'Billing Details',
      backLabel: 'billing info',
      key: CREDIT_FORM_KEYS.BILLING_DETAILS,
      schema: billingDetailsFormSchema,
      fields: [...Object.keys(billingDetailsFormSchema.shape).map((e) => 'billingDetails.' + e)],
    },
    insuranceDetails: {
      showInStepper: true,
      stepLabel: 'Insurance Details',
      backLabel: 'insurance info',
      key: CREDIT_FORM_KEYS.INSURANCE_DETAILS,
      schema: insuranceDetailsFormSchema,
      fields: [
        ...Array.from(
          new Set([
            ...Object.keys(insuranceDetailsFormSchema._def.options[0].shape),
            ...Object.keys(insuranceDetailsFormSchema._def.options[1].shape),
          ]),
        ).map((e) => 'insuranceDetails.' + e),
      ],
    },
    review: {
      showInStepper: StepperVariant.BAR,
      stepLabel: 'Review',
      key: CREDIT_FORM_KEYS.REVIEW,
      fields: [...Object.keys(reviewFormSchema._def.shape).map((e) => 'review.' + e)],
    },
  },
  stepperOrder: ['companyDetails', 'billingDetails', 'insuranceDetails', 'review'],
  stepperStatus: [
    CreditApplicationStatus.STEP1_SAVED,
    CreditApplicationStatus.STEP2_SAVED,
    CreditApplicationStatus.STEP3_SAVED,
    CreditApplicationStatus.SUBMITTED,
  ],
};

export const START_CREDIT_SUMMARY_ANIMATION = 'start-checkout-header-animation';

export const END_CREDIT_SUMMARY_ANIMATION = 'end-checkout-header-animation';

export enum ErrorCodes {
  FORM_ALREADY_SUBMITTED = 'FORM_ALREADY_SUBMITTED',
  UNEXPECTED_ERROR = 'UNEXPECTED_ERROR',
  INVALID_REQUEST = 'INVALID_REQUEST',
  BLOCKED_REQUEST = 'BLOCKED_REQUEST',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  VERIFICATION_FAILED = 'VERIFICATION_FAILED',
  SYSTEM_FAILURE = 'SYSTEM_FAILURE',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED',
  CREDIT_LIMIT_ALREADY_SET = 'CREDIT_LIMIT_ALREADY_SET',
}

export const YearsInBusinessIntlIds = {
  [YearsInBusiness.LESS_THAN_5_YEARS]: 'creditApplication.yearsInBusinessOptions.upto5',
  [YearsInBusiness.GREATER_THAN_EQUAL_TO_6_YEARS]: 'creditApplication.yearsInBusinessOptions.6plus',
};

export const creditApplicationImage =
  'https://uploads-ssl.webflow.com/60cb2013a506c737cfeddf74/658d92f438cd3aca06511ed0_credit_application_image.png';
